<template>
  <div>
    <div>
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="分类">
              <a-cascader
                allowClear
                changeOnSelect
                :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
                :options="where.keyword.type"
                @change="treeChange"
                placeholder="请选择"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="课程名称">
              <a-input placeholder="请输入" v-model="where.keyword.courseName" />
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="课程状态">
              <a-select defaultValue="lucy" v-model="where.keyword.status">
                <a-select-option value="0">全选</a-select-option>
                <a-select-option value="1">未发布</a-select-option>
                <a-select-option value="2">已发布</a-select-option>
                <a-select-option value="3">已关闭</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="课程来源">
              <a-input placeholder="请输入" v-model="where.keyword.courseFrom" />
            </a-form-item>
          </a-col>
          <a-col :span="4" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList">搜索</a-button>
          </a-col>
        </a-row>
       
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows}"
        :locale="{emptyText:'暂无数据'}"
        :scroll="{ x: 1300 }"
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==1" color="green">已发布</a-tag>
          <a-tag v-else-if="status==-1" color="red">未发布</a-tag>
          <a-tag v-else-if="status==2" color="red">直播中</a-tag>
          <a-tag v-else-if="status==3" color="gray">已结束</a-tag>
          <a-tag v-else color="gray">已删除</a-tag>
        </span>
        
        
      </a-table>
      <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
        <pxkeji-btn name="确定并返回" type="primary" @click="selFinish" />
        <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;" />
      </a-form-item>
      
    </div>

    
  </div>
</template>
<script>

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "课程编码"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称"
  },

  {
    dataIndex: "typeName",
    key: "typeName",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "presentPrice",
    key: "presentPrice",
    align: "center",
    title: "价格/元"
  },
  {
    dataIndex: "teacherName",
    key: "teacherName",
    align: "center",
    title: "讲师"
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" }
  }
];

var that;
export default {
  name: "storelist",
   props: {
    courses: Array
  },
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          type: [],
          status: "",
          courseName: "",
          courseFrom: "",
          typeId:"",
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      allSelectRows:[],
      treeData: [],
      switchLoading: false, //开关等待
    
    };
  },
  components: {
   
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.allSelectRows=this.courses;
      this.GetList();
      this.GetCateList();
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    cancelClick() {
      this.$emit("callbackMethod");
    },
    selFinish(){
       if(this.allSelectRows.length==0){
          this.$msg.errorMsg("请选择课程");
       }
       console.log(this.allSelectRows);
       this.$emit("callbackMethod", this.allSelectRows);
    },
   
    onTimeChange(date, dateString) {
      this.where.keyword.time = dateString;
    },
    treeChange(val) {
      this.where.keyword.typeId=val[val.length-1];
    },
    
    GetList() {
      //获取列表
     
      this.isloading = true;
      this.clearRows();
      this.$api.course
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.typeId,
          this.where.keyword.courseName,
          this.where.keyword.courseFrom,
          0,
          this.where.keyword.status,
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            for(var index in this.list.datas){
              for(var i in this.allSelectRows){
                if(this.allSelectRows[i].id==this.list.datas[index].id){
                  this.selectRows.push(this.allSelectRows[i].id)
                }
              }
            }
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
      
      for(var data in this.list.datas){
        var check=false;
        for(var key in selectedRowKeys){
          if(this.list.datas[data].id==selectedRowKeys[key]){
            check=true;
            break;
          }
        }

        if(check){
          var find=false;
          for(var index in this.allSelectRows){
            if(this.allSelectRows[index].id==this.list.datas[data].id){
                find=true;
                break;
            }
          }
          if(!find){
            this.allSelectRows.push({
              id:this.list.datas[data].id,
              name:this.list.datas[data].name
            });
          }
        }else{
            for(var index1 in this.allSelectRows){
              if(this.allSelectRows[index1].id==this.list.datas[data].id){
                  this.allSelectRows.splice(index1,1);
              }
          }
        }
      }

    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    
    GetCateList() {
      //获取列表
      this.isloading = true;
      this.$api.courseType
        .getTreeByColumnId('', '')
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.where.keyword.type = res.data;
            //console.log('asd',this.where.keyword.type)
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    }
   
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

